import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BabyChangingStationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"baby_changing_station"}/>
}
